import type { FC, SVGProps } from 'react';

export const WarningTriangleIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    height="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_4681_1489)">
      <path
        fill="currentColor"
        d="M7.14329 11.7143C7.14329 11.9416 7.2336 12.1596 7.39435 12.3204C7.55509 12.4811 7.77311 12.5714 8.00044 12.5714C8.22777 12.5714 8.44578 12.4811 8.60653 12.3204C8.76727 12.1596 8.85758 11.9416 8.85758 11.7143C8.85758 11.487 8.76727 11.2689 8.60653 11.1082C8.44578 10.9475 8.22777 10.8571 8.00044 10.8571C7.77311 10.8571 7.55509 10.9475 7.39435 11.1082C7.2336 11.2689 7.14329 11.487 7.14329 11.7143ZM7.42901 6.28572V9.57143C7.42901 9.65 7.49329 9.71429 7.57187 9.71429H8.42901C8.50758 9.71429 8.57187 9.65 8.57187 9.57143V6.28572C8.57187 6.20714 8.50758 6.14286 8.42901 6.14286H7.57187C7.49329 6.14286 7.42901 6.20714 7.42901 6.28572ZM15.9237 14.1429L8.49508 1.28571C8.38437 1.09464 8.19329 1 8.00044 1C7.80758 1 7.61472 1.09464 7.50579 1.28571L0.077223 14.1429C-0.14242 14.525 0.13258 15 0.571866 15H15.429C15.8683 15 16.1433 14.525 15.9237 14.1429ZM1.93258 13.6446L8.00044 3.14107L14.0683 13.6446H1.93258Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_4681_1489">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
